import { RouterModule, Routes } from '@angular/router'

import { NgModule } from '@angular/core'
import { CanDeactivateGuard } from '@core/guard/can-deactivate-guard'
import { FolderOverviewComponent } from './foder-overview/folder-overview.component'

const routes: Routes = [
  { path: '', component: FolderOverviewComponent, canDeactivate: [CanDeactivateGuard], children: [] },
]

@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class FolderOverviewRoutingModule {}
